/* eslint-disable import/prefer-default-export */
import { defineStore } from 'pinia';
import axios from 'axios';
export const useCustomFieldStore = defineStore('customFieldStore', {
  state: () => ({
    saving: false,
    alerts: {},
    customFields: [],
    accountingSettings: [],
    matterTags: [],
    accountingState: {}
  }),
  actions: {
    async listCustomFields() {
      try {
        const response = await axios.get('/customfields/options');
        this.$patch({
          customFields: response.data.customFields
        });
        return response.data.customFields;
      } catch (error) {
        this.alerts?.error(error.message || error.response.data.message);
      }
    },
    async getAccountingSettings() {
      try {
        const response = await axios.get('/accounting/settings');
        this.$patch({
          accountingSettings: response?.data
        });
        return response?.data;
      } catch (error) {
        this.alerts?.error(error.message || error.response.data.message);
      }
    },
    async listMatterTags() {
      try {
        const response = await axios.get('/mattertags');
        this.$patch({
          matterTags: response.data
        });
        return response.data;
      } catch (error) {
        this.alerts?.error(error.message || error.response.data.message);
      }
    },
    async verify(prompt) {
      try {
        const status = await axios.get('/accounting');
        if (!status.data.connected) {
          if (prompt) {
            this.alerts?.error('You are disconnected from QuickBooks. Go to Settings to reconnect...');
          } else {
            this.alerts?.error('You are disconnected from QuickBooks');
          }
        }
        this.accountingState.connected = status.data.connected;
        return status.data;
      } catch (error) {
        this.alerts?.error(error.message || error.response.data.message);
      }
    },
    async update(customFields) {
      try {
        const updatedCompany = await axios({
          url: `/me/company`,
          method: 'PUT',
          data: {
            settings: {
              customFields: customFields
            }
          }
        });
        return updatedCompany.data;
      } catch (error) {
        this.alerts?.error(error.message || error.response.data.message);
      }
    }
  }
});